import siteUrl from '@/utils/url/site'
import param from '@/utils/url/param'

export default async (args = {}) => {
  let { fone, whatsapp, end, city, state } = site,
    buttons = [{
      color: "error darken-2",
      icon: 'email',
      text: "email",
      action: siteUrl("contato")
    }]
  end = end + ", " + city + "-" + state
  if (whatsapp) {
    buttons.push({
      color: "success darken-1",
      icon: 'whatsapp',
      text: "Whatsapp",
      action: 'https://api.whatsapp.com/send' +
        param({
          phone: '55' + whatsapp.replace(/[^0-9]+/g, '')
        })
    })
  }
  return {
    msg: `Você pode falar conosco em nosso escritório na <strong>${end}</strong>, ou pelo telefone <strong>${fone}</strong>, ou se preferir, fale conosco via email no link abaixo.`,
    buttons
  }
}